const actions = {
    FETCH_INCREMENT_MONTH_DECLARATIONS: 'FETCH_INCREMENT_MONTH_DECLARATIONS',
    FETCH_INCREMENT_MONTH_DECLARATION: 'FETCH_INCREMENT_MONTH_DECLARATION',
    RESET_INCREMENT_MONTH_DECLARATION: 'RESET_INCREMENT_MONTH_DECLARATION',

    fetchIncrementMonthDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_INCREMENT_MONTH_DECLARATIONS,
            data: data
        };
    },
    resetIncrementMonthDeclarationFormAction: () => {
        return {
            type: actions.RESET_INCREMENT_MONTH_DECLARATION,
            data: null
        };
    },
    fetchIncrementMonthDeclarationAction: (data) => {
        return {
            type: actions.FETCH_INCREMENT_MONTH_DECLARATION,
            data: data
        };
    },
};

export default actions;
